<template>
  <div class="tbe-accordion__item">
    <div
        class="tbe-accordion__trigger"
        :class="{'tbe-accordion__trigger--active': visible}"
        @click.prevent="open"
    >
      <slot name="tbe-accordion-trigger"></slot>
    </div>

    <transition
        name="tbe-accordion"
        @enter="start"
        @after-enter="end"
        @before-leave="start"
        @after-leave="end">

      <div class="tbe-accordion__content" v-if="visible">
          <slot name="tbe-accordion-content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "tbeAccordionItem",

  inject: ["accordion"],

  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },

  data() {
    return {
      index: this.id
    };
  },

  computed: {
    visible() {
      return this.index === this.accordion.active;
    }
  },

  methods: {
    open() {
      this.accordion.active = this.index;

      this.$emit('click:trigger');
    },
    start(el) {
      el.style.height = el.scrollHeight + "px";
    },
    end(el) {
      el.style.height = "";
    }
  }
}
</script>

<style lang="scss" scoped>
.tbe-accordion {
  &__item {
    position: relative;
  }

  &__trigger {}

  &-enter-active,
  &-leave-active {
    will-change: height, opacity;
    transition: height 0.3s ease, opacity 0.3s ease;
    overflow: hidden;
  }

  &-enter-from,
  &-leave-to {
    height: 0 !important;
    opacity: 0;
  }
}
</style>
